import { render, staticRenderFns } from "./PointSecuritymoney.vue?vue&type=template&id=664ba79d"
import script from "./PointSecuritymoney.vue?vue&type=script&lang=js"
export * from "./PointSecuritymoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports